"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FILE_SIZE_OFFSET_FACTOR = exports.MAX_FILE_SIZE_BYTES = void 0;
exports.MAX_FILE_SIZE_BYTES = 1024 ** 2;
exports.MAX_FILE_SIZE_OFFSET_FACTOR = 2;
//# sourceMappingURL=configurations.js.map